import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { ShieldX, ArrowLeft } from 'lucide-react';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-sm px-4">
        <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
          <ShieldX className="h-8 w-8 text-red-500" />
        </div>
        <h2 className="text-xl font-bold text-foreground mb-2">Yetkisiz Erişim</h2>
        <p className="text-muted-foreground text-sm mb-6">
          Bu sayfayı görüntüleme yetkiniz bulunmamaktadır.
        </p>
        <button
          onClick={() => navigate('/dashboard')}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Dashboard'a Dön
        </button>
      </div>
    </div>
  );
};

const ProtectedRoute = ({ children, adminOnly = false, roles = null }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && user.role !== 'admin' && user.role !== 'super_admin') {
    return <UnauthorizedPage />;
  }

  if (roles && !roles.includes(user.role)) {
    return <UnauthorizedPage />;
  }

  return children;
};

export default ProtectedRoute;